import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bullets = ['Entra el dinero... y desaparece', 'Te da ansiedad ver tu cuenta', 'Sabes qué hacer… pero no lo haces', 'Siempre vuelves al mismo punto'];
  return <section className="bg-primary relative overflow-hidden" data-id="element-101">
      <div className="max-w-4xl mx-auto w-full flex flex-col items-center text-center pt-8 pb-10 md:pt-16 md:pb-16 px-4 md:px-12" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center w-full" data-id="element-103">
          <h1 className="font-playfair font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-7xl leading-tight mb-4 md:mb-6 text-warm-white drop-shadow-lg" data-id="element-104">
            El dinero entra… pero nunca te dura.{' '}
            <span className="text-gold" data-id="element-105">No es casualidad:</span> es cómo tu
            cuerpo reacciona al dinero.
          </h1>

          <p className="font-inter text-base md:text-xl text-warm-muted mb-8 md:mb-10 max-w-2xl leading-relaxed px-2" data-id="element-106">
            No es que ganes poco. Tu{' '}
            <span className="text-gold font-semibold" data-id="element-107">sistema nervioso</span>{' '}
            está tomando decisiones por ti…{' '}
            <span className="text-warm-white font-semibold" data-id="element-108">
              sin que te des cuenta
            </span>
            .
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full max-w-sm md:max-w-md rounded-2xl overflow-hidden shadow-glow-gold-lg mb-8 md:mb-10 mx-auto" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/7u94iAcYxpEvrfjCrg93F9/IMAGEN_DEL_PRODUCTO.png" alt="El Protocolo RNS - Ebook digital en tablet" className="w-full h-auto object-cover rounded-2xl" data-id="element-110" />
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 w-full max-w-lg mx-auto mb-8 md:mb-10" data-id="element-111">
            {bullets.map((bullet, idx) => <div key={idx} className="bg-secondary border border-card rounded-xl px-4 py-3.5 flex items-center gap-3 hover:border-gold/40 transition-colors" data-id="element-112">
                <div className="w-8 h-8 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-113">
                  <CheckIcon className="w-4 h-4 text-gold" data-id="element-114" />
                </div>
                <span className="font-inter text-warm-white text-sm md:text-base" data-id="element-115">
                  {bullet}
                </span>
              </div>)}
          </div>

          <button onClick={scrollToPricing} className="w-full max-w-lg bg-gold hover:bg-gold-light transition-all text-primary font-inter font-bold text-sm md:text-base px-6 md:px-10 py-4 md:py-5 rounded shadow-glow-gold hover:shadow-glow-gold-lg mb-5 md:mb-6 transform hover:-translate-y-1" data-id="element-116">
            QUIERO DEJAR DE PERDER DINERO SIN DARME CUENTA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4" data-id="element-117">
            <div className="bg-secondary border border-card rounded-full px-4 py-2 text-warm-muted text-xs md:text-sm font-inter" data-id="element-118">
              Solo 10 minutos al día
            </div>
            <div className="bg-secondary border border-card rounded-full px-4 py-2 text-warm-muted text-xs md:text-sm font-inter" data-id="element-119">
              Descarga inmediata
            </div>
            <div className="bg-secondary border border-card rounded-full px-4 py-2 text-warm-muted text-xs md:text-sm font-inter" data-id="element-120">
              Garantía de 30 días
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}